export const ParticipationClassType = {
    Attendance: 1,
    VirtualEvent1: 2,
    VirtualEvent2: 3,
};
export const isVirtualParticipationClassType = (type) => {
    return type && [ParticipationClassType.VirtualEvent1, ParticipationClassType.VirtualEvent2].includes(type);
};
//# sourceMappingURL=ParticipationClassType.js.map